import React, { Component } from "react";

class Resume extends Component {
  render() {
    return (
      <article className="resume-panel" data-panel="resume">
        <header className="panel-head">
          <h2 data-en="Resume" data-fa="رزومه">
            Resume
          </h2>
          <span className="head-line"></span>
        </header>
        <div className="timeline-wrap">
          <h3 className="sub-title">
            <i className="bi bi-mortarboard"></i>
            <span data-en="Education" data-fa="تحصیلات">
              Education
            </span>
          </h3>
          <div className="timeline">
            <div className="tl-item">
              <span className="tl-date">2022 — 2026</span>
              <h4
                data-en="B.A. Graphic Design"
                data-fa="کارشناسی مهندسی کامپیوتر"
              >
                B.A. Graphic Design
              </h4>
              <p
                data-en="B.Sc. in Computer Engineering
                    Graduated with Honors"
                data-fa=" فارغ‌التحصیل با معدل ممتاز "
              >
                B.Sc. in Computer Engineering
                Graduated with Honors
              </p>
            </div>
            <div className="tl-item">
              <span className="tl-date">2020 — 2022</span>
              <h4 data-en="UI/UX Bootcamp" data-fa="دوره تخصصی رابط کاربری">
                UI/UX Bootcamp
              </h4>
              <p
                data-en="Intensive product design & prototyping program."
                data-fa="برنامه فشرده طراحی محصول و پروتوتایپ"
              >
                Intensive product design &amp; prototyping program
              </p>
            </div>
          </div>
          <h3 className="sub-title">
            <i className="bi bi-briefcase"></i>
            <span data-en="Experience" data-fa="تجربه کاری">
              Experience
            </span>
          </h3>
          <div className="timeline">
            <div className="tl-item">
              <span className="tl-date">
                2025 —
                <span data-en="Now" data-fa="اکنون">
                  Now
                </span>
              </span>
              <h4
                data-en="Product Manager Mana Company"
                data-fa="مدیر محصول شرکت مانا"
              >
                Product Manager Mana Company
              </h4>
              <p
                data-en="Led the development lifecycle of digital products, coordinated cross-functional teams, defined product requirements, and oversaw project execution with a focus on quality and user experience."
                data-fa="هدایت فرآیند توسعه محصولات دیجیتال از مرحله ایده‌پردازی تا اجرا، هماهنگی میان تیم‌های طراحی، توسعه و محتوا، تعریف نیازمندی‌ها و نظارت بر اجرای پروژه‌ها با تمرکز بر کیفیت و تجربه کاربری"
              >
                Led the development lifecycle of digital products, coordinated
                cross-functional teams, defined product requirements, and
                oversaw project execution with a focus on quality and user
                experience
              </p>
            </div>
            <div className="tl-item">
              <span className="tl-date">
                2024 —
                <span data-en="Now" data-fa="اکنون">
                  Now
                </span>
              </span>
              <h4
                data-en="Content Manager & Front-End Developer Mana Company"
                data-fa="مدیر محتوا و توسعه‌دهنده فرانت‌اند شرکت مانا"
              >
                Content Manager & Front-End Developer Mana Company
              </h4>
              <p
                data-en="Planned and managed digital content strategy while developing responsive web interfaces, collaborating with design teams, and enhancing user experience across digital projects."
                data-fa="برنامه‌ریزی و مدیریت استراتژی محتوای دیجیتال، توسعه و بهینه‌سازی وب‌سایت، همکاری با تیم طراحی و توسعه و ارائه راهکارهای خلاقانه برای ارتقای تجربه کاربری و حضور دیجیتال برند"
              >
                Planned and managed digital content strategy while developing
                responsive web interfaces, collaborating with design teams, and
                enhancing user experience across digital projects
              </p>
            </div>
            <div className="tl-item">
              <span className="tl-date">
                2024 —
                <span data-en="Now" data-fa="اکنون">
                  Now
                </span>
              </span>
              <h4
                data-en="Lead UI/UX Designer Shivanegar Project"
                data-fa="طراح ارشد سیستم شیوانگار"
              >
                Lead UI/UX Designer Shivanegar Project
              </h4>
              <p
                data-en="Led the UI/UX design of Shivanegar, a Microsoft Word extension for academic writing and thesis preparation."
                data-fa="رهبری طراحی رابط کاربری و تجربه کاربری افزونه تخصصی شیوانگار برای نگارش پایان‌نامه و مقالات در ورد"
              >
                Led the UI/UX design of Shivanegar, a Microsoft Word extension
                for academic writing and thesis preparation
              </p>
            </div>
            <div className="tl-item">
              <span className="tl-date">2025-2026</span>
              <h4
                data-en="Executive Team Member | Yazd Game Zone"
                data-fa="عضو تیم اجرایی رویداد Yazd Game Zone"
              >
                Executive Team Member | Yazd Game Zone
              </h4>
              <p
                data-en="Collaborated in the coordination and execution of a technology and game development event in Yazd Province."
                data-fa="همکاری در هماهنگی و اجرای یکی از رویدادهای تخصصی حوزه بازی سازی و فناوری در استان یزد"
              >
                Built responsive interfaces with HTML, CSS &amp; JS
              </p>
            </div>
            <div className="tl-item">
              <span className="tl-date">2024-2025</span>
              <h4
                data-en="Event Manager"
                data-fa="مدیر اجرایی رویدادهای استانی"
              >
                Event Manager
              </h4>
              <p
                data-en="Collaborated in the coordination and execution of a technology and game development event in Yazd Province."
                data-fa="برنامه‌ریزی، مدیریت و اجرای رویدادهای گل یا پوچ و Level Up در سطح استان یزد"
              >
                Managed and executed provincial events including Gol Ya Pooch
                and Level Up
              </p>
            </div>
            <div className="tl-item">
              <span className="tl-date">2024</span>
              <h4
                data-en="Technical Support Specialist | International Badminton Championship"
                data-fa="پشتیبان فنی مسابقات بین‌المللی بدمینتون"
              >
                Technical Support Specialist | International Badminton
                Championship
              </h4>
              <p
                data-en="Provided technical support and operational assistance during an international badminton tournament."
                data-fa="ارائه پشتیبانی فنی و همکاری در زیرساخت‌های اجرایی مسابقات بین‌المللی بدمینتون"
              >
                Managed and executed provincial events including Gol Ya Pooch
                and Level Up
              </p>
            </div>
            <div className="tl-item">
              <span className="tl-date">2022-2023-2024</span>
              <h4
                data-en="Technology Exhibition Representative"
                data-fa=" نمایشگاه‌های فن‌بازار استان یزد"
              >
                Technology Exhibition Representative
              </h4>
              <p
                data-en="Participated in Yazd Technology Marketplace (Fan Bazaar) exhibitions, representing innovative products and engaging with technology companies."
                data-fa="مشارکت در برگزاری، معرفی محصولات و تعامل با شرکت‌های فناور در نمایشگاه‌های فن‌بازار استان یزد"
              >
                Participated in Yazd Technology Marketplace (Fan Bazaar)
                exhibitions, representing innovative products and engaging with
                technology companies
              </p>
            </div>
            <div className="tl-item">
              <span className="tl-date">
                2022-
                <span data-en="Now" data-fa="اکنون">
                  Now
                </span>
              </span>
              <h4
                data-en="Digital Content Consultant"
                data-fa="مشاور و تولیدکننده محتوای دیجیتال"
              >
                Digital Content Consultant
              </h4>
              <p
                data-en="Collaborated with local businesses across Yazd Province to develop content strategies, produce social media content, and enhance digital brand presence."
                data-fa="همکاری با کسب‌وکارهای مختلف استان یزد در زمینه طراحی استراتژی محتوا، تولید محتوای شبکه‌های اجتماعی، طراحی گرافیک و توسعه هویت دیجیتال برند"
              >
                Collaborated with local businesses across Yazd Province to
                develop content strategies, produce social media content, and
                enhance digital brand presence
              </p>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

export default Resume;
